var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("article", { staticClass: "box" }, [
      _c("div", { staticClass: "columns" }, [
        _vm._m(0),
        _c("div", { staticClass: "column is-narrow" }, [
          !_vm.isLoadingInvoice
            ? _c("div", { staticClass: "buttons" }, [
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.$user.hasEdit(_vm.$route.meta.id) &&
                          !_vm.readOnlyView &&
                          !_vm.isUpdateInvoice &&
                          _vm.invoice &&
                          !_vm.invoice.gstPaidDate,
                        expression:
                          "$user.hasEdit($route.meta.id) && !readOnlyView && !isUpdateInvoice && invoice && !invoice.gstPaidDate",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Update Invoice" },
                    on: {
                      click: function ($event) {
                        return _vm.editInvoice()
                      },
                    },
                  },
                  [_vm._m(1)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.$user.hasAdd(_vm.$route.meta.id) &&
                          !_vm.invoice &&
                          !_vm.readOnlyView,
                        expression:
                          "$user.hasAdd($route.meta.id) && !invoice && !readOnlyView",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "New Invoice" },
                    on: {
                      click: function ($event) {
                        return _vm.addInvoice()
                      },
                    },
                  },
                  [_vm._m(2)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.$user.hasDelete(_vm.$route.meta.id) &&
                            !_vm.readOnlyView &&
                            !_vm.isUpdateInvoice &&
                            _vm.invoice &&
                            !_vm.invoice.gstPaidDate) ||
                          (_vm.invoice && _vm.invoice.isNew),
                        expression:
                          "$user.hasDelete($route.meta.id) && !readOnlyView && !isUpdateInvoice && invoice && !invoice.gstPaidDate || (invoice && invoice.isNew)",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Delete Invoice" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteInvoice()
                      },
                    },
                  },
                  [_vm._m(3)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.$user.hasEdit(_vm.$route.meta.id) &&
                          _vm.isUpdateInvoice &&
                          _vm.invoice &&
                          !_vm.invoice.isNew,
                        expression:
                          "$user.hasEdit($route.meta.id) && isUpdateInvoice && invoice && !invoice.isNew",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Update from quote" },
                    on: {
                      click: function ($event) {
                        return _vm.updateInvoice()
                      },
                    },
                  },
                  [_vm._m(4)]
                ),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isUpdateInvoice &&
                          _vm.invoice &&
                          !_vm.invoice.isNew,
                        expression:
                          "isUpdateInvoice && invoice && !invoice.isNew",
                      },
                    ],
                    staticClass: "button tooltip",
                    attrs: { "data-tooltip": "Cancel" },
                    on: {
                      click: function ($event) {
                        return _vm.cancelInvoice()
                      },
                    },
                  },
                  [_vm._m(5)]
                ),
              ])
            : _vm._e(),
          _vm.invoice && _vm.invoice.gstPaidDate
            ? _c(
                "span",
                {
                  staticClass:
                    "tag is-warning is-pulled-right tooltip is-tooltip-warning",
                  attrs: { "data-tooltip": "GST has been paid" },
                },
                [
                  _vm._v(
                    "GST paid on " +
                      _vm._s(
                        _vm.$filters.formatDateTimezone(
                          _vm.invoice.gstPaidDate,
                          _vm.$userInfo.locale
                        )
                      )
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      !_vm.invoice && _vm.isLoadingInvoice
        ? _c("div", { staticClass: "section" }, [
            _c("span", {
              staticClass: "is-loading-image has-text-grey has-text-centered",
            }),
          ])
        : _vm.invoice
        ? _c(
            "div",
            { staticStyle: { height: "93%", "align-self": "stretch" } },
            [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Invoice No."),
                  ]),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: {
                          type: "text",
                          placeholder: "Invoice No.",
                          readonly: "",
                        },
                        domProps: { value: _vm.invoiceNoReference },
                      }),
                    ]),
                  ]),
                ]),
                !_vm.isUpdateInvoice
                  ? _c("div", { staticClass: "field" }, [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Invoice Date"),
                      ]),
                      _c("input", {
                        staticClass: "input is-static",
                        attrs: { readonly: "" },
                        domProps: {
                          value: _vm.$filters.formatDateTimezone(
                            _vm.selectedInvoiceDate,
                            _vm.$userInfo.locale
                          ),
                        },
                      }),
                    ])
                  : _vm.$userInfo && !_vm.gstPaid && _vm.selectedInvoiceDate
                  ? _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Invoice Date"),
                        ]),
                        _c("v-date-picker", {
                          attrs: {
                            "is-dark": _vm.$theme.isDark,
                            masks: _vm.formats,
                            attributes: _vm.attrs,
                            locale: _vm.$userInfo.locale,
                            "min-date": _vm.firstDayOfMonth,
                            timezone: _vm.$filters.getIanaTimezone(),
                          },
                          on: {
                            input: function ($event) {
                              _vm.selectedInvoiceDate =
                                _vm.$filters.fromISOWithCurrentTime(
                                  $event.toISOString()
                                )
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ inputValue, inputEvents }) {
                                return [
                                  _c("div", { staticClass: "field" }, [
                                    _c(
                                      "div",
                                      { staticClass: "control has-icons-left" },
                                      [
                                        _c(
                                          "input",
                                          _vm._g(
                                            {
                                              staticClass: "input",
                                              attrs: {
                                                type: "text",
                                                placeholder: "Date To...",
                                                readonly: "",
                                              },
                                              domProps: { value: inputValue },
                                            },
                                            inputEvents
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "icon is-small is-left",
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "mdi mdi-calendar mdi-18px",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.selectedInvoiceDate,
                            callback: function ($$v) {
                              _vm.selectedInvoiceDate = $$v
                            },
                            expression: "selectedInvoiceDate",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "is-divider" }),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Payer")]),
                _c("input", {
                  staticClass: "input is-static",
                  attrs: { type: "text", readonly: "" },
                  domProps: { value: _vm.invoice.assetName },
                }),
              ]),
              _c("div", { staticClass: "is-divider" }),
              _c("label", { staticClass: "label" }, [_vm._v("Exported")]),
              _c(
                "div",
                { staticClass: "pretty p-icon p-curve p-smooth p-bigger" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.invoice.exported,
                        expression: "invoice.exported",
                      },
                    ],
                    attrs: {
                      id: "chk-invoice-exported",
                      name: "chk-invoice-exported",
                      type: "checkbox",
                      disabled:
                        _vm.readOnlyView || !_vm.$userInfo.isSupportUser,
                    },
                    domProps: {
                      checked: Array.isArray(_vm.invoice.exported)
                        ? _vm._i(_vm.invoice.exported, null) > -1
                        : _vm.invoice.exported,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.invoice.exported,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.invoice,
                                "exported",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.invoice,
                                "exported",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.invoice, "exported", $$c)
                        }
                      },
                    },
                  }),
                  _vm._m(6),
                ]
              ),
              _c("div", { staticClass: "is-divider" }),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Total Excl GST: "),
                  _c("span", { staticClass: "has-text-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.totalExGst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("GST: "),
                  _c("span", { staticClass: "has-text-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.gst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Total Payable Incl GST: "),
                  _c("span", { staticClass: "has-text-success" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatCurrency(
                          _vm.totalPayableIncGst,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Invoice")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-refresh mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-warning" }, [
      _c("i", { staticClass: "mdi mdi-close mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-primary" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label", [_vm._v("Exported")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }